import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { newVendorModalSlice, NewVendorModalState } from '@REDUCERS';

function createNewVendorModalHook() {
    return function useNewVendorModal(equalityFn?: EqualityFn<NewVendorModalState>) {
        const state = useAppSelector((store) => store.newVendorModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: () => dispatch(newVendorModalSlice.actions.open()),
            close: () => dispatch(newVendorModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createNewVendorModalHook();
